export function downloadFile (fileUrl: string, fileName: string): void {
  const a: HTMLAnchorElement = document.createElement("a");

  a.href = fileUrl;
  a.target = "_blank";
  a.download = fileName;
  document.body.append(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(fileUrl);
}
